import {createSelector} from "reselect";

const authSelector = state => state.auth;

export const authChallengeSelector = store => authSelector(store).challenge;
export const authUserSelector = store => authSelector(store).user;

export const authTokenSelector = store => authSelector(store).token;
export const authAccessTokenSelector = store => authTokenSelector(store).access_token;
export const authTokenExpiresAtSelector = createSelector(
  [authTokenSelector],
  token => token && token.expires_at * 1000
);

export const authIsAuthenticatedSelector = store => !!authTokenSelector(store);
export const authUsernameSelector = createSelector(
  [authUserSelector],
  authUser => authUser && authUser.email
);

export const authForgotPasswordSubmittedSelector = createSelector(
  [authSelector],
  auth => auth.forgotPasswordSubmitted
);

export const authForgotPasswordUsernameSelector = createSelector(
  [authSelector],
  auth => auth.forgotPasswordUsername
);